import moment, { Moment } from 'moment'
import { MomentInput } from 'moment'
import { EST_TO_UTC_OFFSET } from '../../../global/constants/date'

function offsetDate(date: MomentInput): Moment {
  return moment.utc(date).add(EST_TO_UTC_OFFSET, 'hours')
}

export default offsetDate
